import { localeCountryCodeMap } from '../components/LanguageSelector/utils';
import { getParsedLanguage } from './supportedLocales';

// getting locales marked as "New" in language selector
const newLanguages = Object.keys(localeCountryCodeMap).filter(
  (locale) => localeCountryCodeMap[locale].isNew,
);

export const getNewSupportedBrowserLanguage = (): string | undefined => {
  // we check for full inclusion as well to support pt-br
  const newLanguage = navigator?.languages?.find(
    (language) =>
      newLanguages.includes(language) || newLanguages.includes(language.substring(0, 2)),
  );

  return getParsedLanguage(newLanguage);
};
